module.exports = __webpack_public_path__ + "img/monthly_earn_transaction_count.8eff860b.svg";